import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ContactPage from "../pages/contact/page";
import CustomerOperationsPage from "../pages/services/customer-operations/page";
import FinanceOperationsPage from "../pages/services/finance-operations/page";
import SalesOperationsPage from "../pages/services/sales-operations/page";
import InternalWorkflowsPage from "../pages/services/internal-workflows/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  // Home-section addresses: plain paths so any link handler (incl. preview hosts) navigates correctly.
  { path: "/services", element: <Home /> },
  { path: "/approach", element: <Home /> },
  { path: "/outcomes", element: <Home /> },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/services/customer-operations",
    element: <CustomerOperationsPage />,
  },
  {
    path: "/services/finance-operations",
    element: <FinanceOperationsPage />,
  },
  {
    path: "/services/sales-operations",
    element: <SalesOperationsPage />,
  },
  {
    path: "/services/internal-workflows",
    element: <InternalWorkflowsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
